<template>
  <InputWrapper
    v-model="model"
    className="input-row--text"
    :name="name"
    :error="error"
    :label="label"
    :disabled="disabled ?? false"
    :hasIconLeft="hasIconLeft"
    :hasIconRight="hasIconRight"
    :placeholder="placeholder || (mask ?? undefined)"
  >
    {{ model }}
    <template #icon>
      <slot name="icon"></slot>
    </template>

    <template #input>
      <input
        :id="`${name}`"
        :name="`${name}`"
        ref="input-text"
        type="text"
        v-model="model"
        v-maska="mask ?? undefined"
        :placeholder="placeholder ?? mask ?? undefined"
        class="form-input form-input--text"
        :disabled="disabled ?? undefined"
        @blur="onBlur"
        @keyup.enter="onEnter"
        @keypress="onKeypress"
      />
    </template>

    <template #icon-right>
      <slot name="icon-right"></slot>
    </template>
  </InputWrapper>
</template>

<script setup lang="ts">
import { vMaska } from 'maska/vue';
import { useTemplateRef } from 'vue';

import InputWrapper from './InputWrapper.vue';

const model = defineModel<string>();
const emit = defineEmits(['onEnter', 'onBlur', 'onKeypress']);

const inputText = useTemplateRef('input-text');

withDefaults(
  defineProps<{
    label?: string;
    labelPos?: string;
    disabled?: boolean | null;
    id?: string;
    mask?: string;
    name?: string;
    error?: string;
    hasIconLeft?: boolean;
    hasIconRight?: boolean;
    placeholder?: string;
  }>(),
  {
    label: '',
    labelPos: 'top',
    disabled: null,
    id: undefined,
    name: '',
    error: '',
    hasIconLeft: false,
    hasIconRight: false,
    placeholder: '',
  },
);

const onBlur = (e: FocusEvent) => {
  emit('onBlur', e);
};

const onKeypress = (e: KeyboardEvent) => {
  emit('onKeypress', e);
};

const onEnter = (e: KeyboardEvent) => {
  emit('onEnter', e);
};

defineExpose({
  inputText,
});
</script>
